import { Button, Loader, Portal } from '@nazka/nazka.mapframe.components';
import { toast } from 'react-toastify';

import { useQRCode } from '@services/query.service';
import { useTranslation } from '@utils/i18n/i18n.consumers';

import './share-popup.styl';

function SharePopup({
  qrCodeText,
  onClose,
}) {
  const { t } = useTranslation();

  const { data: qrCodeUrl, isLoading } = useQRCode(qrCodeText);

  function handleCopy() {
    navigator.clipboard.writeText(qrCodeText);
    toast.success(t('Link copied to clipboard'));
  }

  return (
    <Portal>
      <div className="share-popup">
        <div className="share-popup__content">
          <h2>
            {t('Share this link')}
          </h2>
          <div className="share-popup__content__link">
            <span onClick={handleCopy}>
              {qrCodeText}
            </span>
            <Button
              className="share-popup__content__link__copy"
              layout="outlined"
              onClick={handleCopy}
            >
              {t('Copy')}
            </Button>
          </div>
          {isLoading && <Loader />}
          {qrCodeUrl && <img src={qrCodeUrl} alt="QR Code" />}
          <Button
            className="share-popup__content__close"
            onClick={onClose}
          >
            {t('Close')}
          </Button>
        </div>
      </div>
    </Portal>
  );
}

export default SharePopup;